@if (order$ | async; as order) {
  <div class="header row ml-0 d-flex justify-content-between">
    <div class="alert alert-secondary justify-content-start" role="alert">
      <h3><b><i>Check Scheduled Delivery Dates at Line item</i></b></h3>
    </div>
    <div class="col-lg-2 mt-3" [formGroup]="detailsForm">
      <ng-select class="mb-1" formControlName="statusFilter" bindLabel="Text" bindValue="Key" placeholder="All"
        [items]="lineItemstatuses" [searchable]="false" [clearable]="false" (change)="statusChange($event)" bindLabel="Text" bindValue="Key">
      </ng-select>
      <label class="text-muted">{{ 'knbrOrderDetails.label.filterByStatus' | cxTranslate }}</label>
    </div>
  </div>
  @if (this.inlineOrders) {
    <div class="col-12 col-sm float-left p-0 mb-3">
      @for (item of this.inlineOrders; track item; let i = $index) {
        <div class="col-12 col-sm float-left p-0 align-items-center" [ngClass]="{ 'border-2': item.showLineItem }">
          @if (item.showLineItem === true) {
            <div >
              <div class="col-lg-2 col-md-2 col-sm float-left p-0 order-details" [ngClass]="{ 'unconsigned-item': !item.consignmentEntry }">
                @if (item.product.showInCatalog === 'Yes' && item.showLineItem === true) {
                  <a [routerLink]="{ cxRoute: 'product', params: getProductRouteParams(item.product) } | cxUrl" [queryParams]="getProductQueryParams(item.product)" cxModal="dismiss" tabindex="-1"
                    >
                    <cx-media [container]="item.product?.images" format="product"></cx-media>
                  </a>
                }
                @if (item.product.showInCatalog !== 'Yes') {
                  <a tabindex="-1">
                    <cx-media [container]="item.product?.images" format="product"></cx-media>
                  </a>
                }
              </div>
              <div class="col-lg-10 col-md-10 col-sm float-left">
                <div class="col-lg-12 col-md-12 d-flex pl-0">
                  <div class="col-lg-9 col-md-9 col-sm float-left p-0 pt-2 pb-2 border-bottom">
                    <label class="font-text-400 color-font font-size-18">{{ item.product?.code }}</label>
                    @if (item.product?.name) {
                      <div >
                        @if (item.product.showInCatalog === 'Yes') {
                        <a class="text-muted font-text-400"
                          [routerLink]="{ cxRoute: 'product', params:  getProductRouteParams(item.product) } | cxUrl"
                          [queryParams]="getProductQueryParams(item.product)" cxModal="dismiss"><b>{{ item.product?.name }}</b></a>
                        }
                          @if (item.product.showInCatalog !== 'Yes') {
                            <a class="text-muted font-text-400" ><b>{{ item.product?.name }}</b></a>
                          }
                        </div>
                      }
                    </div>
                    <div class="col-lg-3 col-md-3 text-right">
                      <button class="mt-3 btn btn-primary" (click)="navigateToCaseCreation(item.product.code, item.entryNumber)" ngbTooltip="{{createCasetoolTipText}}" triggers="hover" placement="top-right">
                        <img src="images/create-case-icon.svg" class="pb-1">
                        Submit Case
                      </button>
                    </div>
                  </div>
                  @if (!(isOrderEditable$ | async)) {
                    <div class="col-lg-12 col-md-12 col-sm float-left p-0 pt-2 pb-2 border-1" [ngClass]="{ 'border-bottom': item.consignmentEntry }">
                      <div class="col-lg-1 col-md-1 col-sm float-left p-0">
                        <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.poNumber2' | cxTranslate}}</label>
                        <p class="text-muted mb-1 text-align-right mr-3">{{item.purchaseOrderNumber ? item.purchaseOrderNumber : '-' }}</p>
                      </div>
                      <div class="col-lg-1 col-md-1 col-sm float-left p-0">
                        <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.qty' | cxTranslate }}</label>
                        <p class="text-muted mb-1 text-align-right mr-3">{{ item?.quantity?.toLocaleString() }} {{ item.uom }}</p>
                      </div>
                      <div class="col-lg-2 col-md-2 col-sm float-left p-0">
                        <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.plant' | cxTranslate }}</label>
                        <p class="text-muted mb-1">{{ item.plant }}</p>
                      </div>
                      <div class="col-lg-1 col-md-1 col-sm float-left p-0">
                        <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.lineItemStatus' | cxTranslate }}</label>
                        <p class="text-muted mb-1">{{ item.lineItemStatus }}</p>
                      </div>
                      <!-- <div class="col-md-1 col-sm float-left p-0" *ngIf="item.knbrQuoteReference && item.knbrQuoteReference?.quoteRefNumber">
                      <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.quoteId' | cxTranslate }}</label>
                      <p class="text-muted mb-1">{{ item.knbrQuoteReference?.quoteRefNumber }}</p>
                    </div> -->
                    <div class="col-lg-1 col-md-1 col-sm float-left p-0">
                      <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.openQuantity' | cxTranslate }}</label>
                      <p class="text-muted mb-2">{{ item.openQuantity?.toLocaleString() }} {{ item.uom }}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm float-left p-0">
                      <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.termsOfDelivery' | cxTranslate }}</label>
                      <p class="text-muted mb-2">{{ item.incoTerm }}</p>
                    </div>
                    <div class="col-lg-1 col-md-1 float-left p-0">
                      <label class="color-font font-text-400 order-details-table-row-height font-weight-bold pr-2">{{ 'knbrOrderDetails.label.unitNetPrice' | cxTranslate }}</label>
                      <p class="text-align-right text-muted mb-2">{{ getPriceUnit(order.knbrOrderType, item) }}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 float-left p-0">
                      <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.shipTo' | cxTranslate }}</label>
                      <p class="text-muted mb-1 word-wrap">{{ item?.shipTo }}</p>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm float-left p-0">
                      <label class="color-font font-text-400 order-details-table-row-height font-weight-bold">{{ 'knbrOrderDetails.label.quoteReference' | cxTranslate }}</label>
                      <a class="mb-1 cursor-pointer" (click)="navigateToQuote(item?.quoteRefNumber)">{{ item?.quoteRefNumber ? item?.quoteRefNumber : '-' }}</a>
                    </div>
                  </div>
                }
                @if (isOrderEditable$ | async) {
                  <knbr-kn-br-edit-order-item [item]="item"
                    (inputChange)="onQuantityChange($event)">
                  </knbr-kn-br-edit-order-item>
                }
                <ng-container>
                  <!-- <div class="col-12 pl-0"> -->
                  <div ngbAccordion [closeOthers]="true" class="scheduled-accordion-styles">
                    <div ngbAccordionItem [collapsed]="true">
                      <div ngbAccordionHeader class="d-flex">
                        <button ngbAccordionButton class="btn btn-link d-flex justify-content-between">
                          <div class="d-flex mr-3">Scheduled Delivery Dates</div>
                        </button>
                      </div>
                      <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                          <ng-template>
                            @if (item && item?.scheduleLines?.length) {
                              <div class="row counter-wrapper">
                                <div class="customersearch-list-table float-left col-lg-12 mt-1">
                                  <div class="float-left w-100">
                                    <div class="col-md-4 float-left pl-0 py-2 font-weight-bold color-font">Scheduled Qty</div>
                                    <div class="col-md-4 float-left pl-0 py-2 font-weight-bold color-font">Scheduled Date</div>
                                  </div>
                                  @for (item of item?.scheduleLines; track item) {
                                    <div class="bg-white table-content float-left w-100 py-2 font-weight-normal d-flex align-items-center">
                                      <div class="col-md-4 float-left title-wrap font-md-size text-muted mb-1 text-align-right">
                                        <span class="res-titles"> {{ 'invoiceResult.header.document' | cxTranslate }}:</span>
                                        {{ item.scheduledQuantity?.toLocaleString() }} {{ item.uom }}
                                      </div>
                                      <div class="col-md-4 float-left title-wrap pl-2 font-md-size text-muted mb-1">
                                        <span class="res-titles"> {{ 'invoiceResult.header.documentDate' | cxTranslate }}:</span>
                                        {{ item.scheduledDate }}
                                      </div>
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <ngb-accordion #acc="ngbAccordion" class="scheduled" activeIds="ngb-panel-0" [closeOthers]="true" (panelChange)="showHide($event, acc)">
                  <ngb-panel class="w-100 float-left mb-2 text-muted font-size-18">
                    <ng-template ngbPanelTitle="">
                      <div class="d-flex justify-content-between">
                        <div class="d-flex">Scheduled Delivery Dates</div>
                        <div class="d-flex"><i class="fas ml-3 mt-1" [ngClass]="this.show && this.index == i ? 'fa-chevron-up' : 'fa-chevron-down'"></i></div>
                      </div>
                    </ng-template>
                    <ng-template ngbPanelContent>
                      <div class="row counter-wrapper" *ngIf="item && item?.scheduleLines?.length">
                        <div class="customersearch-list-table float-left col-lg-12 mt-1">
                          <div class="float-left w-100">
                            <div class="col-md-4 float-left pl-0 py-2 font-weight-bold color-font">Scheduled Qty</div>
                            <div class="col-md-4 float-left pl-0 py-2 font-weight-bold color-font">Scheduled Date</div>
                          </div>
                          <div class="bg-white table-content float-left w-100 py-2 font-weight-normal d-flex align-items-center" *ngFor="let item of item?.scheduleLines">
                            <div class="col-md-4 float-left title-wrap font-md-size text-muted mb-1 text-align-right">
                              <span class="res-titles"> {{ 'invoiceResult.header.document' | cxTranslate }}:</span>
                              {{ item.scheduledQuantity?.toLocaleString() }} {{ item.uom }}
                            </div>
                            <div class="col-md-4 float-left title-wrap pl-2 font-md-size text-muted mb-1">
                              <span class="res-titles"> {{ 'invoiceResult.header.documentDate' | cxTranslate }}:</span>
                              {{ item.scheduledDate }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                  </ngb-panel>
                </ngb-accordion> -->
              <!-- </div> -->
            </ng-container>
            <ng-container>
              <div class="col-2 float-left p-0 pt-2 pb-2">
                <label class="w-100 float-left mb-2 text-muted font-size-18"><b>{{'knbrOrderDetails.label.shipments' | cxTranslate }}</b>
              </label>
            </div>
            @if (item?.dropShipment) {
              <div class="col-10 float-left p-0 pt-2 pb-2 border-1">
                <span><i>No information available, please contact customer service</i></span>
              </div>
            }
            @for (consignment of item.shipments; track consignment) {
              <div class="col-12 float-left p-0 pt-2 pb-2">
                <div class="col-12 float-left p-0">
                  <div class="col-1 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.qtyShipped' | cxTranslate}}</label>
                    <p class="text-muted mb-1">{{ consignment.qtyShipped }} {{ item.uom }}</p>
                  </div>
                  <div class="col-1 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.shipDate' | cxTranslate}}</label>
                    <p class="text-muted mb-1">{{ consignment.shippedDate }}</p>
                  </div>
                  <div class="col-2 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.status' | cxTranslate}}</label>
                    <p class="text-muted mb-1 ml-2">{{ consignment.shippedStatus }}</p>
                  </div>
                  <div class="col-1 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.deliveryNumber' | cxTranslate}}</label>
                    <p class="text-muted mb-1">{{ consignment.deliveryNumber }}</p>
                  </div>
                  <div class="col-2 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.shippingType' | cxTranslate}}</label>
                    <p class="text-muted mb-1">{{ consignment.shippingType }}</p>
                  </div>
                  <div class="col-2 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.carrier' | cxTranslate}}</label>
                    <p class="text-muted mb-1">{{ consignment.shipmentCarrier === 'FREIGHT WATCHERS INC.' ? 'Carrier Assignment Pending' : consignment.shipmentCarrier }}</p>
                  </div>
                  <div class="col-3 float-left p-0">
                    <label class="color-font font-text-400 mb-1">{{'knbrOrderDetails.label.trackingId' | cxTranslate}}</label>
                    @if (consignment.trackingId && consignment.trackingUrl) {
                      <span>
                        <a class="mb-1 cursor-pointer cx-link" href="{{consignment.trackingUrl}}" target="_blank">{{ consignment.trackingId }}</a>
                      </span>
                    } @else {
                      <span class="text-muted mb-1">{{ 'knbrOrderDetails.label.call' | cxTranslate}}</span>
                    }
                  </div>
                </div>
              </div>
            }
          </ng-container>
        </div>
      </div>
    }
  </div>
}
</div>
}
<div class="col-md-12 float-right d-flex justify-content-center mt-2">
  <button type="button" class="btn btn-action" (click)="goBack()">
    {{ 'knbrOrderDetails.actions.backOrderHistory' | cxTranslate }}
  </button>
</div>
}
<ng-container>
  @if (isOrderEditable$ | async) {
    <kn-br-add-products (inputChange)="onInputChange($event)">
    </kn-br-add-products>
  }</ng-container>
